<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :errors="{}"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <ul v-if="pendingInviteTeacher">
        <li>
          {{ pendingInviteTeacher }}
        </li>
      </ul>
      <div class="actions">
        <primary-button
          @click.native="closeModal"
        >
          {{ $t('classes.create_class_flow.list_students_modal.got_it') }}
        </primary-button>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'

  export default {
    components: {
      Modal,
      PrimaryButton
    },
    props: {
      pendingInviteTeacher: {
        type: String,
        default: null,
      },
    },
    methods: {
      closeModal() {
        this.$emit('closed')
      },
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog.elsa-modal {
    background-color: #F2F7FA;
  }
  ul {
    list-style: none;
    padding: 0;
    li {
      background: #F9FBFD;
      padding: 0 24px;
      margin-bottom: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      img {
        display: none;
      }
      &:hover img {
        display: block;
      }
    }
  }
  .actions {
    align-items: flex-start;
    .el-button {
      padding: 12px;
    }
  }
  .warning-no-student {
    color: #E6A23C;
    align-items: center;
    font-size: 16px;
  }

</style>
